import { SwitchState } from '@/interface/enum';
import useState from '@/libraries/composables/useState';
import type { IEuroTicket } from '@/libraries/euroTicket';

export function useSwitchStateTracker() {
    const [switchState, setSwitchState] = useState(SwitchState.None);
    const [isFirstOpenTicketAfterPlaceBet, setIsFirstOpenTicketAfterPlaceBet] = useState(false);

    function updateGaSwitchState(currentTicket: IEuroTicket, newTicket: IEuroTicket) {
        if (!isFirstOpenTicketAfterPlaceBet.value) {
            setIsFirstOpenTicketAfterPlaceBet(true);
            return;
        }

        if (currentTicket.oddsId === newTicket.oddsId && currentTicket.option === newTicket.option) {
            return;
        }

        if (currentTicket.eventId !== newTicket.eventId) {
            setSwitchState(SwitchState.Match);
            return;
        }

        if (currentTicket.marketType !== newTicket.marketType) {
            if (switchState.value !== SwitchState.Match) {
                setSwitchState(SwitchState.Market);
            }
            return;
        }

        if (currentTicket.option !== newTicket.option) {
            if (switchState.value !== SwitchState.Match && switchState.value !== SwitchState.Market) {
                setSwitchState(SwitchState.Option);
            }
        }
    }

    function resetSwitchState() {
        setSwitchState(SwitchState.None);
        setIsFirstOpenTicketAfterPlaceBet(false);
    }

    return {
        switchState,
        updateGaSwitchState,
        resetSwitchState,
    };
}
